import React from 'react';

const SettingForm = ({ mode, setmode, config, updateconfig, setconfig, title }) => {

  if (mode !== "showusersettingform") return null;

  const handleconfigchange = (value) => {
    // Keep the config as a string while editing in textarea
    setconfig({ ...config, config: value });
  };

  // Ensure the value in textarea is always a string (pretty-printed JSON if it's an object)
  const displayValue = typeof config?.config === 'object' 
    ? JSON.stringify(config.config, null, 2) 
    : config?.config || "";

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={() => setmode("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>{title} Config (JSON)</label>
            <textarea
              className="form-input"
              style={{ height: '300px', fontFamily: 'monospace' }}
              value={displayValue}
              onChange={(e) => handleconfigchange(e.target.value)}
            />
          </div>
          <button className="btn-blue full-width" onClick={updateconfig}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default SettingForm;

